import produce from 'immer';
import type React from 'react';
import type {
  SearchBarValue,
  SearchBarCommandCreatedInfo,
  SearchBarFilter,
} from '@fabric-app/business/search/searchbar.types';
import FilterPill from './FilterPill';

export const FilterPills: React.FC<{
  value: SearchBarValue;
  setValue: React.Dispatch<React.SetStateAction<SearchBarValue>>;
  onRecoverLastCommand?: () => void;
  setLastCommandCreated?: (data: SearchBarCommandCreatedInfo | null) => void;
  lastCommandCreated?: React.MutableRefObject<SearchBarCommandCreatedInfo | null>;
}> = ({ value, setValue, setLastCommandCreated, lastCommandCreated, onRecoverLastCommand }) => {
  const { filters } = value;

  const recoverLastCommand = () => {
    if (!lastCommandCreated?.current) return;
    const { match, position } = lastCommandCreated.current;
    const newQuery = value.query.slice(0, position) + match + value.query.slice(position);
    setValue((prevValue) => ({
      ...prevValue,
      query: newQuery,
    }));
    setLastCommandCreated?.(null);

    setTimeout(() => {
      /**
       * @TODO
       */
      // inputRef.current?.focus();
      // inputRef.current?.setSelectionRange(position + match.length, position + match.length);
      onRecoverLastCommand?.();
    }, 0);
  };

  const setFilter = ($key: string) => (filter: SearchBarFilter) => {
    setValue((prevValue) => {
      const index = prevValue.filters.findIndex((f) => f.$key === $key);
      if (index === -1) return prevValue;

      const newFilters = [...prevValue.filters];
      newFilters[index] = filter;
      return { ...prevValue, filters: newFilters };
    });
  };

  const deleteFilter = ($key: string) => () => {
    if (
      lastCommandCreated?.current?.$key === $key &&
      value.filters.find((f) => f.$key === $key)?.value === null
    ) {
      recoverLastCommand();
    }

    setValue(
      produce((draft: SearchBarValue) => {
        const index = draft.filters.findIndex((f) => f.$key === $key);
        if (index === -1) return;

        draft.filters.splice(index, 1);
      }),
    );
  };

  return filters.map((filter) => (
    <FilterPill
      key={`${filter.$key}`}
      filter={filter}
      setFilter={setFilter(filter.$key)}
      deleteFilter={deleteFilter(filter.$key)}
      autoFocus={filter.value === null}
    />
  ));
};
